module.exports = __webpack_public_path__ + "img/30@2x.ac99e72.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/cooperation/30@2x.png
// module id = xbJp
// module chunks = 0